const Translation = {
    title: "株式会社和映",
    nav: {
        about: "会社概要",
        contact: "連絡先",
    },
    about: {
        title: "会社概要",
        desc_1: "株式会社和映はCM、映像制作を中心とする企画、制作、配信、人員派遣など全般サービスを提供する会社です。",
        desc_2: ""
    },
    contact: {
        title: "連絡先",
        desc_1: "Han Mengxin",
        desc_2: "TEL: +81 03-6914-4070 / +81 080-6501-0978",
        desc_3: "E-MAIL: mengxin_han@waei.one",
        desc_4: "ADDRESS: 东京都世田谷区楼 3-29-4-101",
    },
    article: {
        rental_price: "レンタル価格",
        characteristic: "CHARACTERISTIC",
        accessories: "ACCESSORIES",
        specification: "SPECIFICATION",
        related_equipment: "RELATED EQUIPMENT",
    },
    common: {
        more: "MORE",
    },
}

export default Translation;
